import React from 'react';
import { useTranslation } from 'react-i18next';

// « Terminer mon livre » (correctif 12, 2026-10-16).
//
// Cette fenetre n'est plus un INVENTAIRE (59 photos, 11 souvenirs, 30 pages, coches vertes, puis avertissements
// orange) : « Terminer mon livre » mene DIRECTEMENT a l'apercu complet. Les conseils (nettete, pli, pages
// vides) vivent sur l'apercu, en une banniere calme et facultative (voir BookPreviewFinalLuxe.js).
//
// Elle ne s'ouvre plus que pour une VRAIE erreur bloquante : un livre ENTIEREMENT vide (rien a previsualiser ni a
// imprimer). Un bouton ramene a l'endroit a corriger. Des pages vides parmi d'autres ne bloquent pas : un livre
// de 30 pages avec quelques photos est un livre legitime, signale comme conseil seulement.
function AtelierFinishModal({ isOpen, onClose, onGoToPage, pageIndex = 0 }) {
  const { t } = useTranslation('atelier');
  if (!isOpen) return null;

  return (
    <div className="atelier-modal-backdrop" onClick={onClose}>
      <div className="atelier-modal" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <div className="atelier-modal-head">
          <h2 className="atelier-modal-title">{t('finishModal.blockingTitle')}</h2>
          <button type="button" className="atelier-modal-close" onClick={onClose} aria-label={t('common.close')}>×</button>
        </div>
        <p className="atelier-finish-blocking">{t('finishModal.blockingText')}</p>
        <div className="atelier-modal-actions">
          <button type="button" className="btn btn-primary" onClick={() => { onClose(); if (onGoToPage) onGoToPage(pageIndex); }}>
            {t('finishModal.goToPage', { number: pageIndex + 1 })}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AtelierFinishModal;
